import { styled, SxProps } from '@mui/system';
import { makeStyles } from '@mui/styles';
import { Container, Stack, Typography } from '@mui/material';
import * as React from 'react';
import LiteYouTubeEmbed from 'react-lite-youtube-embed';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';

export interface LandingVideoProps {
  videoID: string;
  title?: string;
  sx?: SxProps;
}

const YoutubeStyles = makeStyles({
  root: {
    height: '400px',
    borderRadius: '16px'
  }
});

const RootStyle = styled('div')();
export const LandingVideo = ({ videoID, title, sx }: LandingVideoProps) => {
  const classes = YoutubeStyles();
  return (
    <RootStyle>
      <Container maxWidth={'md'} sx={sx}>
        <Stack spacing={10}>
          {title && (
            <>
              <Typography
                sx={{
                  textAlign: 'center',
                  display: {
                    xl: 'block',
                    lg: 'block',
                    md: 'block',
                    sm: 'none',
                    xs: 'none'
                  }
                }}
                variant={'h2'}
              >
                {title}
              </Typography>
              <Typography
                sx={{
                  textAlign: 'center',
                  display: {
                    xl: 'none',
                    lg: 'none',
                    md: 'none',
                    sm: 'block',
                    xs: 'block'
                  }
                }}
                variant={'h4'}
              >
                {title}
              </Typography>
            </>
          )}
          <Container maxWidth={'md'}>
            <LiteYouTubeEmbed
              id={videoID}
              title="YouTube video player"
              poster="maxresdefault"
              wrapperClass={`yt-lite ${classes.root}`}
            />
          </Container>
        </Stack>
      </Container>
    </RootStyle>
  );
};
